export class SignupDto {
	constructor(
		public email: string,
		public password: string,
		public returnUrl: string) {}
}